
const getDishes = (row, field) => {
  const items = row.original[field]?.dish;
  return Array.isArray(items) && items.length > 0 ? items.join(', ') : '';
};


export function menuColumns({ t }) {
  const columns = [
    {
      Header: '№',
      accessor: 'rowNumber',
      width: 60,
      filterable: false
    },
    // {
    //   Header: <ColumnSorting title={t('menuPage_startDateColumns')} name='startDate' />,
    //   accessor: 'startDate',
    //   Cell: row => row.original.startDate ? moment(row.original.startDate).format('DD.MM.YYYY') : row.original.startDate,
    //   sortable: false,
    //   filterable: false,
    //   style: { textAlign: 'center' },
    // },
    // {
    //   Header: <ColumnSorting title={t('menuPage_endDateColumns')} name='endDate' />,
    //   accessor: 'endDate',
    //   Cell: row => row.original.endDate ? moment(row.original.endDate).format('DD.MM.YYYY') : row.original.endDate,
    //   sortable: false,
    //   filterable: false,
    //   style: { textAlign: 'center' },
    // },
    // {
    //   Header: t('menuPage_ageGroup') || 'Возрастная группа',
    //   accessor: 'ageGroupId',
    //   Cell: row =>
    //     getAgeGroupName(row.original.ageGroupId, ageGroupsDict, lang),
    //   sortable: false,
    //   filterable: false,
    //   style: { textAlign: 'center' },
    // },
    {
      Header: t('menu_breakfast') || 'Завтрак',
      accessor: 'breakfast',
      Cell: row => getDishes(row, 'breakfast'),
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' },
    },
    {
      Header: t('menu_secondBreakfast') || 'Второй завтрак',
      accessor: 'secondBreakfast',
      Cell: row => getDishes(row, 'secondBreakfast'),
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' },
    },
    {
      Header: t('menu_lunch') || 'Обед',
      accessor: 'lunch',
      Cell: row => getDishes(row, 'lunch'),
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' },
    },
    {
      Header: t('menu_snack') || 'Полдник',
      accessor: 'snack',
      Cell: row => getDishes(row, 'snack'),
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' },
    },
    {
      Header: t('menu_dinner') || 'Ужин',
      accessor: 'dinner',
      Cell: row => getDishes(row, 'dinner'),
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' },
    },
    {
      Header: t('menu_lateDinner') || 'Поздний ужин',
      accessor: 'lateDinner',
      Cell: row => getDishes(row, 'lateDinner'),
      sortable: false,
      filterable: false,
      style: { textAlign: 'center' }
    }
  ];
  // if (!hasRestrictedRole) {
  //   columns.push({
  //     Header: t('menuPage_actions') || 'Действия',
  //     accessor: 'actions',
  //     width: 100,
  //     filterable: false,
  //     sortable: false,
  //     Cell: ({ original }) => (
  //       <Tooltip placement="top" title={t('menuPage_edit')}>
  //         <IconButton
  //           color="primary"
  //           size="small"
  //           onClick={e => {
  //             e.stopPropagation();
  //             onEdit(original);
  //           }}
  //         >
  //           <EditIcon fontSize="small" />
  //         </IconButton>
  //       </Tooltip>
  //     ),
  //     style: { textAlign: 'center' }
  //   });
  // }


  return columns;
}

